import { default as _91token_93pwj7qEcmpiMeta } from "/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/auth/[token].vue?macro=true";
import { default as _91code_93UpiGcOiqp7Meta } from "/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/changepwd/[code].vue?macro=true";
import { default as forgotPwdaRzfnNhgEXMeta } from "/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/forgotPwd.vue?macro=true";
import { default as index9AA5ayo1zVMeta } from "/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/index.vue?macro=true";
import { default as _91loginCode_93MotaYbnVcrMeta } from "/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/LeaderGroup/[loginCode].vue?macro=true";
import { default as leaderQZMGJ76ZOSMeta } from "/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/LeaderGroup/leader.vue?macro=true";
import { default as travelerTn656LIqSMMeta } from "/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/LeaderGroup/traveler.vue?macro=true";
import { default as loginf6iZM7Rt12Meta } from "/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/login.vue?macro=true";
import { default as accountReceivableoniqVWoz8xMeta } from "/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/accountReceivable.vue?macro=true";
import { default as adjustAcoountBGYBgK2DLhMeta } from "/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/adjustAcoount.vue?macro=true";
import { default as accountReceivable_bk0429NqQC77BGVyMeta } from "/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/backup/accountReceivable_bk0429.vue?macro=true";
import { default as companyMembeBk2604091mtI69tWTUMeta } from "/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/backup/companyMembeBk260409.vue?macro=true";
import { default as companyTravelerBK260414YIxYBhYWmTMeta } from "/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/backup/companyTravelerBK260414.vue?macro=true";
import { default as draft_bk260625e5DLlK79ibMeta } from "/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/backup/draft_bk260625.vue?macro=true";
import { default as expendFundMange_bk260527je9g5PXkZdMeta } from "/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/backup/expendFundMange_bk260527.vue?macro=true";
import { default as expendManage_bk260512yNjntZO9JKMeta } from "/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/backup/expendManage_bk260512.vue?macro=true";
import { default as myGroup_bk260625htdQL4L0YIMeta } from "/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/backup/myGroup_bk260625.vue?macro=true";
import { default as myOrderBk_260401OveEf67Rs4Meta } from "/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/backup/myOrderBk_260401.vue?macro=true";
import { default as paymentManagement_bk260522qqrMcXqnLkMeta } from "/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/backup/paymentManagement_bk260522.vue?macro=true";
import { default as template_bk2606258lv1bP3K3QMeta } from "/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/backup/template_bk260625.vue?macro=true";
import { default as CheckPaymentPPqlwYZzIjMeta } from "/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/CheckPayment.vue?macro=true";
import { default as commentManagement0CdqTwvAjNMeta } from "/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/commentManagement.vue?macro=true";
import { default as companyAccountEgCxRKa4SjMeta } from "/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/companyAccount.vue?macro=true";
import { default as companyMemberOR8IpgNc3sMeta } from "/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/companyMember.vue?macro=true";
import { default as companyOverviewEmGPdCdhgtMeta } from "/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/companyOverview.vue?macro=true";
import { default as companyTravelerETiitvvjrcMeta } from "/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/companyTraveler.vue?macro=true";
import { default as companyVendorMk895YNw25Meta } from "/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/companyVendor.vue?macro=true";
import { default as CreditCardPaymentyzhqnPWTkwMeta } from "/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/CreditCardPayment.vue?macro=true";
import { default as customFormz7igIIxFE5Meta } from "/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/customForm.vue?macro=true";
import { default as dailyClosing_oldk64yra9rM8Meta } from "/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/dailyClosing_old.vue?macro=true";
import { default as _91date_93EMPleHw9iEMeta } from "/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/dailyClosing/[method]/[date].vue?macro=true";
import { default as indexrbk44Dds3cMeta } from "/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/dailyClosing/index.vue?macro=true";
import { default as draftD1WPHRfZGUMeta } from "/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/draft.vue?macro=true";
import { default as expendFundMangeuCK81V6zCVMeta } from "/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/expendFundMange.vue?macro=true";
import { default as expendManageyIo8TYDBBBMeta } from "/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/expendManage.vue?macro=true";
import { default as expendWorkwF9BZhGsaEMeta } from "/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/expendWork.vue?macro=true";
import { default as eleTypevpdyAp4KAUMeta } from "/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/finance/acc/eleType.vue?macro=true";
import { default as finance4NIAovnEBbMeta } from "/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/finance/acc/finance.vue?macro=true";
import { default as indexGuyKNykce0Meta } from "/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/finance/acc/index.vue?macro=true";
import { default as payToolsUfad79BVgXMeta } from "/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/finance/acc/payTools.vue?macro=true";
import { default as fitx2xIyYTHBfMeta } from "/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/finance/end/fit.vue?macro=true";
import { default as indexvHMkz4YvnRMeta } from "/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/finance/end/index.vue?macro=true";
import { default as tourp77x4elPDSMeta } from "/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/finance/end/tour.vue?macro=true";
import { default as balance2SYNDjZKk0Meta } from "/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/finance/report/balance.vue?macro=true";
import { default as cashQ75J2CsTm3Meta } from "/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/finance/report/cash.vue?macro=true";
import { default as comparebalance8JMYgIUK2HMeta } from "/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/finance/report/comparebalance.vue?macro=true";
import { default as compareincomeSkqxJD08K1Meta } from "/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/finance/report/compareincome.vue?macro=true";
import { default as incomeZZnrW7QminMeta } from "/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/finance/report/income.vue?macro=true";
import { default as indexrxou1r30O0Meta } from "/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/finance/report/index.vue?macro=true";
import { default as transactionZGpQSizuDOMeta } from "/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/finance/transaction.vue?macro=true";
import { default as voucherfBtOGHvww4Meta } from "/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/finance/voucher.vue?macro=true";
import { default as fitProductwgEFn79nxaMeta } from "/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/fitProduct.vue?macro=true";
import { default as _91product_932afZNSNzpFMeta } from "/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/groupSetting/[method]/[product].vue?macro=true";
import { default as _91product_93Cpn7WigPE6FvMeta } from "/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/groupSetting/[method]/[product]Cp.vue?macro=true";
import { default as endTour4a8xFK7c5oMeta } from "/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/groupSetting/[product]/endTour.vue?macro=true";
import { default as _91orderuid_93JUVwvaMlntMeta } from "/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/groupSetting/order/[orderuid].vue?macro=true";
import { default as _91orderuid_93yysyHOBClaMeta } from "/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/groupSetting/order/endOrder/[orderuid].vue?macro=true";
import { default as indexK3VOY3jNM1Meta } from "/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/index.vue?macro=true";
import { default as indexCtrlIU6ASiARrGMeta } from "/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/indexCtrl.vue?macro=true";
import { default as infokjoSiMCyFsMeta } from "/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/info.vue?macro=true";
import { default as InvoiceManage0v1mt8DUu8Meta } from "/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/InvoiceManage.vue?macro=true";
import { default as message9KFvxV7MPCMeta } from "/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/message.vue?macro=true";
import { default as monthClosingNH62xzesDoMeta } from "/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/monthClosing.vue?macro=true";
import { default as myGroupO7125AhidcMeta } from "/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/myGroup.vue?macro=true";
import { default as myOrders8mJUrhs38Meta } from "/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/myOrder.vue?macro=true";
import { default as myTrashGroupS8c7NZ0ZfIMeta } from "/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/myTrashGroup.vue?macro=true";
import { default as myTravelerGGy8sZsumRMeta } from "/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/myTraveler.vue?macro=true";
import { default as myTravelOther4Mhwbaco2YMeta } from "/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/myTravelOther.vue?macro=true";
import { default as myWaitGroupRla4EwXSgDMeta } from "/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/myWaitGroup.vue?macro=true";
import { default as notificationG720lFhFtZMeta } from "/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/notification.vue?macro=true";
import { default as monthaXSoqwu6W8Meta } from "/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/order/month.vue?macro=true";
import { default as reportgTy0sjJDR7Meta } from "/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/order/report.vue?macro=true";
import { default as OrderClosing08naT9J2xpMeta } from "/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/OrderClosing.vue?macro=true";
import { default as addPurchaseUI3e5eq2HYMeta } from "/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/othermanage/addPurchase.vue?macro=true";
import { default as discountCouponpqPp3oUsxWMeta } from "/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/othermanage/discountCoupon.vue?macro=true";
import { default as edSettingk52OMRDVBmMeta } from "/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/othermanage/edSetting.vue?macro=true";
import { default as element4GIsJaK6LjMeta } from "/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/othermanage/element.vue?macro=true";
import { default as hightLightznPqq1xKBeMeta } from "/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/othermanage/hightLight.vue?macro=true";
import { default as _91package_933QRkj3bsWUMeta } from "/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/othermanage/Hightlight/package/[package].vue?macro=true";
import { default as hightLightPackagelnlossm5u8Meta } from "/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/othermanage/hightLightPackage.vue?macro=true";
import { default as pnrSettingrRHrbvGykRMeta } from "/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/othermanage/pnrSetting.vue?macro=true";
import { default as printSettingdK6qKGQRnMMeta } from "/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/othermanage/printSetting.vue?macro=true";
import { default as _91package_9372lRImU89BMeta } from "/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/othermanage/QA/package/[package].vue?macro=true";
import { default as qalistnUeJB4gEIlMeta } from "/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/othermanage/qalist.vue?macro=true";
import { default as qapackage0vhNr0LUvlMeta } from "/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/othermanage/qapackage.vue?macro=true";
import { default as _91package_93V39zqbqjy6Meta } from "/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/othermanage/remark/package/[package].vue?macro=true";
import { default as remark3QZICZyK2PMeta } from "/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/othermanage/remark.vue?macro=true";
import { default as remarkPackageptXOECpSrQMeta } from "/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/othermanage/remarkPackage.vue?macro=true";
import { default as otherManagementj6H1Eg44sqMeta } from "/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/otherManagement.vue?macro=true";
import { default as outDataabhqGFtHfiMeta } from "/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/outData.vue?macro=true";
import { default as overviewJzFBMgScp5Meta } from "/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/overview.vue?macro=true";
import { default as _91method_9386YrnkszdcMeta } from "/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/parameter/[method].vue?macro=true";
import { default as payClosingoqa0JZbjUXMeta } from "/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/payClosing.vue?macro=true";
import { default as paymentDeposit3m8Dv1AeC5Meta } from "/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/paymentDeposit.vue?macro=true";
import { default as paymentManagementgqBxdGQhlaMeta } from "/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/paymentManagement.vue?macro=true";
import { default as paymentReceiptSBJ8znIIqQMeta } from "/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/paymentReceipt.vue?macro=true";
import { default as paymentReceiptOpenOeGK2f36RxMeta } from "/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/paymentReceiptOpen.vue?macro=true";
import { default as paymentSettingWqNNxzl3aRMeta } from "/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/paymentSetting.vue?macro=true";
import { default as ProClosingnEsK12Amv7Meta } from "/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/ProClosing.vue?macro=true";
import { default as productP4xRL5HNFlMeta } from "/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/product.vue?macro=true";
import { default as _91product_93uME1R7B172Meta } from "/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/proFunc/[method]/[docMethod]/[product].vue?macro=true";
import { default as _91product_93hDoKUiQ6rQMeta } from "/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/proFunc/[method]/addPurchase/[product].vue?macro=true";
import { default as _91product_93601yjlaTbmMeta } from "/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/proFunc/[method]/contract/[product].vue?macro=true";
import { default as _91product_93v1LNggU9CyMeta } from "/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/proFunc/[method]/edcard/[product].vue?macro=true";
import { default as _91product_93lc1X44lkmzMeta } from "/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/proFunc/[method]/eedoc/[product].vue?macro=true";
import { default as _91product_93Z4ct297XPqMeta } from "/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/proFunc/[method]/hotelList/[product].vue?macro=true";
import { default as _91product_9324LizgYCdIMeta } from "/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/proFunc/[method]/pnrSetting/[product].vue?macro=true";
import { default as _91type_93MDTEHTGpHRMeta } from "/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/proFunc/[method]/price/[product]/[type].vue?macro=true";
import { default as _91product_93QiYDlaHbnXMeta } from "/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/proFunc/[method]/print/[product].vue?macro=true";
import { default as _91product_93vJMEUzQSehMeta } from "/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/proFunc/[method]/QA/[product].vue?macro=true";
import { default as _91product_937JM5a7lh1tMeta } from "/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/proFunc/[method]/QApackage/[product].vue?macro=true";
import { default as _91product_93ActetLKtWkMeta } from "/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/proFunc/[method]/remark/[product].vue?macro=true";
import { default as _91product_93HOvDVLTaH3Meta } from "/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/proFunc/[method]/roomList/[product].vue?macro=true";
import { default as _91product_93VVUS1KHYf9Meta } from "/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/proFunc/[method]/special/[product].vue?macro=true";
import { default as _91product_93Esv56QAAzzMeta } from "/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/proFunc/[method]/traffic/[product].vue?macro=true";
import { default as monthfZ4LHu0DEZMeta } from "/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/report/month.vue?macro=true";
import { default as viewReports1AuqYwNW8Meta } from "/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/report/viewReport.vue?macro=true";
import { default as yearQVQTvwoIplMeta } from "/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/report/year.vue?macro=true";
import { default as SettingSendManageJRrMTn9rnYMeta } from "/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/SettingSendManage.vue?macro=true";
import { default as templatetH7dx7z8TjMeta } from "/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/template.vue?macro=true";
import { default as ThirdPartyPaymentfXx0BIbZ88Meta } from "/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/ThirdPartyPayment.vue?macro=true";
import { default as manageSWFPoRKxazMeta } from "/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage.vue?macro=true";
import { default as memberloginPkUSwl8hK5Meta } from "/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/memberlogin.vue?macro=true";
import { default as membersignupiLfFZAbeVYMeta } from "/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/membersignup.vue?macro=true";
import { default as signupsEllySFhZUMeta } from "/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/signup.vue?macro=true";
import { default as verificationOtr11bwqgmMeta } from "/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/verification.vue?macro=true";
import { default as _91loginCode_93nVWCvSlQ2FMeta } from "~/pages/LeaderGroup/[loginCode].vue?macro=true";
import { default as myGroupFm6wcicm6RMeta } from "~/pages/manage/myGroup?macro=true";
import { default as manageAwBqtF9fvfMeta } from "~/pages/manage.vue?macro=true";
export default [
  {
    name: "auth-token",
    path: "/auth/:token()",
    component: () => import("/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/auth/[token].vue").then(m => m.default || m)
  },
  {
    name: "changepwd-code",
    path: "/changepwd/:code()",
    component: () => import("/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/changepwd/[code].vue").then(m => m.default || m)
  },
  {
    name: "forgotPwd",
    path: "/forgotPwd",
    component: () => import("/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/forgotPwd.vue").then(m => m.default || m)
  },
  {
    name: "index",
    path: "/",
    component: () => import("/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "LeaderGroup-loginCode",
    path: "/LeaderGroup/:loginCode()",
    component: () => import("/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/LeaderGroup/[loginCode].vue").then(m => m.default || m)
  },
  {
    name: "LeaderGroup-leader",
    path: "/LeaderGroup/leader",
    meta: leaderQZMGJ76ZOSMeta || {},
    component: () => import("/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/LeaderGroup/leader.vue").then(m => m.default || m)
  },
  {
    name: "LeaderGroup-traveler",
    path: "/LeaderGroup/traveler",
    meta: travelerTn656LIqSMMeta || {},
    component: () => import("/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/LeaderGroup/traveler.vue").then(m => m.default || m)
  },
  {
    name: "login",
    path: "/login",
    component: () => import("/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/login.vue").then(m => m.default || m)
  },
  {
    name: manageSWFPoRKxazMeta?.name,
    path: "/manage",
    component: () => import("/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage.vue").then(m => m.default || m),
    children: [
  {
    name: "manage-accountReceivable",
    path: "accountReceivable",
    component: () => import("/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/accountReceivable.vue").then(m => m.default || m)
  },
  {
    name: "manage-adjustAcoount",
    path: "adjustAcoount",
    component: () => import("/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/adjustAcoount.vue").then(m => m.default || m)
  },
  {
    name: "manage-backup-accountReceivable_bk0429",
    path: "backup/accountReceivable_bk0429",
    component: () => import("/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/backup/accountReceivable_bk0429.vue").then(m => m.default || m)
  },
  {
    name: "manage-backup-companyMembeBk260409",
    path: "backup/companyMembeBk260409",
    component: () => import("/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/backup/companyMembeBk260409.vue").then(m => m.default || m)
  },
  {
    name: "manage-backup-companyTravelerBK260414",
    path: "backup/companyTravelerBK260414",
    component: () => import("/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/backup/companyTravelerBK260414.vue").then(m => m.default || m)
  },
  {
    name: "manage-backup-draft_bk260625",
    path: "backup/draft_bk260625",
    component: () => import("/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/backup/draft_bk260625.vue").then(m => m.default || m)
  },
  {
    name: "manage-backup-expendFundMange_bk260527",
    path: "backup/expendFundMange_bk260527",
    component: () => import("/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/backup/expendFundMange_bk260527.vue").then(m => m.default || m)
  },
  {
    name: "manage-backup-expendManage_bk260512",
    path: "backup/expendManage_bk260512",
    component: () => import("/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/backup/expendManage_bk260512.vue").then(m => m.default || m)
  },
  {
    name: "manage-backup-myGroup_bk260625",
    path: "backup/myGroup_bk260625",
    component: () => import("/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/backup/myGroup_bk260625.vue").then(m => m.default || m)
  },
  {
    name: "manage-backup-myOrderBk_260401",
    path: "backup/myOrderBk_260401",
    component: () => import("/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/backup/myOrderBk_260401.vue").then(m => m.default || m)
  },
  {
    name: "manage-backup-paymentManagement_bk260522",
    path: "backup/paymentManagement_bk260522",
    component: () => import("/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/backup/paymentManagement_bk260522.vue").then(m => m.default || m)
  },
  {
    name: "manage-backup-template_bk260625",
    path: "backup/template_bk260625",
    component: () => import("/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/backup/template_bk260625.vue").then(m => m.default || m)
  },
  {
    name: "manage-CheckPayment",
    path: "CheckPayment",
    component: () => import("/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/CheckPayment.vue").then(m => m.default || m)
  },
  {
    name: "manage-commentManagement",
    path: "commentManagement",
    component: () => import("/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/commentManagement.vue").then(m => m.default || m)
  },
  {
    name: "manage-companyAccount",
    path: "companyAccount",
    component: () => import("/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/companyAccount.vue").then(m => m.default || m)
  },
  {
    name: "manage-companyMember",
    path: "companyMember",
    component: () => import("/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/companyMember.vue").then(m => m.default || m)
  },
  {
    name: "manage-companyOverview",
    path: "companyOverview",
    component: () => import("/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/companyOverview.vue").then(m => m.default || m)
  },
  {
    name: "manage-companyTraveler",
    path: "companyTraveler",
    component: () => import("/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/companyTraveler.vue").then(m => m.default || m)
  },
  {
    name: "manage-companyVendor",
    path: "companyVendor",
    component: () => import("/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/companyVendor.vue").then(m => m.default || m)
  },
  {
    name: "manage-CreditCardPayment",
    path: "CreditCardPayment",
    component: () => import("/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/CreditCardPayment.vue").then(m => m.default || m)
  },
  {
    name: "manage-customForm",
    path: "customForm",
    component: () => import("/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/customForm.vue").then(m => m.default || m)
  },
  {
    name: "manage-dailyClosing_old",
    path: "dailyClosing_old",
    component: () => import("/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/dailyClosing_old.vue").then(m => m.default || m)
  },
  {
    name: "manage-dailyClosing-method-date",
    path: "dailyClosing/:method()/:date()",
    component: () => import("/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/dailyClosing/[method]/[date].vue").then(m => m.default || m)
  },
  {
    name: "manage-dailyClosing",
    path: "dailyClosing",
    component: () => import("/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/dailyClosing/index.vue").then(m => m.default || m)
  },
  {
    name: "manage-draft",
    path: "draft",
    component: () => import("/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/draft.vue").then(m => m.default || m)
  },
  {
    name: "manage-expendFundMange",
    path: "expendFundMange",
    component: () => import("/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/expendFundMange.vue").then(m => m.default || m)
  },
  {
    name: "manage-expendManage",
    path: "expendManage",
    component: () => import("/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/expendManage.vue").then(m => m.default || m)
  },
  {
    name: "manage-expendWork",
    path: "expendWork",
    component: () => import("/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/expendWork.vue").then(m => m.default || m)
  },
  {
    name: "manage-finance-acc-eleType",
    path: "finance/acc/eleType",
    component: () => import("/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/finance/acc/eleType.vue").then(m => m.default || m)
  },
  {
    name: "manage-finance-acc-finance",
    path: "finance/acc/finance",
    component: () => import("/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/finance/acc/finance.vue").then(m => m.default || m)
  },
  {
    name: "manage-finance-acc",
    path: "finance/acc",
    component: () => import("/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/finance/acc/index.vue").then(m => m.default || m)
  },
  {
    name: "manage-finance-acc-payTools",
    path: "finance/acc/payTools",
    component: () => import("/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/finance/acc/payTools.vue").then(m => m.default || m)
  },
  {
    name: "manage-finance-end-fit",
    path: "finance/end/fit",
    component: () => import("/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/finance/end/fit.vue").then(m => m.default || m)
  },
  {
    name: "manage-finance-end",
    path: "finance/end",
    component: () => import("/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/finance/end/index.vue").then(m => m.default || m)
  },
  {
    name: "manage-finance-end-tour",
    path: "finance/end/tour",
    component: () => import("/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/finance/end/tour.vue").then(m => m.default || m)
  },
  {
    name: "manage-finance-report-balance",
    path: "finance/report/balance",
    component: () => import("/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/finance/report/balance.vue").then(m => m.default || m)
  },
  {
    name: "manage-finance-report-cash",
    path: "finance/report/cash",
    component: () => import("/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/finance/report/cash.vue").then(m => m.default || m)
  },
  {
    name: "manage-finance-report-comparebalance",
    path: "finance/report/comparebalance",
    component: () => import("/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/finance/report/comparebalance.vue").then(m => m.default || m)
  },
  {
    name: "manage-finance-report-compareincome",
    path: "finance/report/compareincome",
    component: () => import("/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/finance/report/compareincome.vue").then(m => m.default || m)
  },
  {
    name: "manage-finance-report-income",
    path: "finance/report/income",
    component: () => import("/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/finance/report/income.vue").then(m => m.default || m)
  },
  {
    name: "manage-finance-report",
    path: "finance/report",
    component: () => import("/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/finance/report/index.vue").then(m => m.default || m)
  },
  {
    name: "manage-finance-transaction",
    path: "finance/transaction",
    component: () => import("/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/finance/transaction.vue").then(m => m.default || m)
  },
  {
    name: "manage-finance-voucher",
    path: "finance/voucher",
    component: () => import("/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/finance/voucher.vue").then(m => m.default || m)
  },
  {
    name: "manage-fitProduct",
    path: "fitProduct",
    component: () => import("/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/fitProduct.vue").then(m => m.default || m)
  },
  {
    name: "manage-groupSetting-method-product",
    path: "groupSetting/:method()/:product()",
    component: () => import("/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/groupSetting/[method]/[product].vue").then(m => m.default || m)
  },
  {
    name: "manage-groupSetting-method-productCp",
    path: "groupSetting/:method()/:product()Cp",
    component: () => import("/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/groupSetting/[method]/[product]Cp.vue").then(m => m.default || m)
  },
  {
    name: "manage-groupSetting-product-endTour",
    path: "groupSetting/:product()/endTour",
    component: () => import("/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/groupSetting/[product]/endTour.vue").then(m => m.default || m)
  },
  {
    name: "manage-groupSetting-order-orderuid",
    path: "groupSetting/order/:orderuid()",
    component: () => import("/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/groupSetting/order/[orderuid].vue").then(m => m.default || m)
  },
  {
    name: "manage-groupSetting-order-endOrder-orderuid",
    path: "groupSetting/order/endOrder/:orderuid()",
    component: () => import("/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/groupSetting/order/endOrder/[orderuid].vue").then(m => m.default || m)
  },
  {
    name: "manage",
    path: "",
    component: () => import("/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/index.vue").then(m => m.default || m)
  },
  {
    name: "manage-indexCtrl",
    path: "indexCtrl",
    component: () => import("/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/indexCtrl.vue").then(m => m.default || m)
  },
  {
    name: "manage-info",
    path: "info",
    component: () => import("/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/info.vue").then(m => m.default || m)
  },
  {
    name: "manage-InvoiceManage",
    path: "InvoiceManage",
    component: () => import("/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/InvoiceManage.vue").then(m => m.default || m)
  },
  {
    name: "manage-message",
    path: "message",
    component: () => import("/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/message.vue").then(m => m.default || m)
  },
  {
    name: "manage-monthClosing",
    path: "monthClosing",
    component: () => import("/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/monthClosing.vue").then(m => m.default || m)
  },
  {
    name: "manage-myGroup",
    path: "myGroup",
    component: () => import("/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/myGroup.vue").then(m => m.default || m)
  },
  {
    name: "manage-myOrder",
    path: "myOrder",
    component: () => import("/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/myOrder.vue").then(m => m.default || m)
  },
  {
    name: "manage-myTrashGroup",
    path: "myTrashGroup",
    component: () => import("/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/myTrashGroup.vue").then(m => m.default || m)
  },
  {
    name: "manage-myTraveler",
    path: "myTraveler",
    component: () => import("/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/myTraveler.vue").then(m => m.default || m)
  },
  {
    name: "manage-myTravelOther",
    path: "myTravelOther",
    component: () => import("/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/myTravelOther.vue").then(m => m.default || m)
  },
  {
    name: "manage-myWaitGroup",
    path: "myWaitGroup",
    component: () => import("/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/myWaitGroup.vue").then(m => m.default || m)
  },
  {
    name: "manage-notification",
    path: "notification",
    component: () => import("/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/notification.vue").then(m => m.default || m)
  },
  {
    name: "manage-order-month",
    path: "order/month",
    component: () => import("/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/order/month.vue").then(m => m.default || m)
  },
  {
    name: "manage-order-report",
    path: "order/report",
    component: () => import("/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/order/report.vue").then(m => m.default || m)
  },
  {
    name: "manage-OrderClosing",
    path: "OrderClosing",
    component: () => import("/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/OrderClosing.vue").then(m => m.default || m)
  },
  {
    name: "manage-othermanage-addPurchase",
    path: "othermanage/addPurchase",
    component: () => import("/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/othermanage/addPurchase.vue").then(m => m.default || m)
  },
  {
    name: "manage-othermanage-discountCoupon",
    path: "othermanage/discountCoupon",
    component: () => import("/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/othermanage/discountCoupon.vue").then(m => m.default || m)
  },
  {
    name: "manage-othermanage-edSetting",
    path: "othermanage/edSetting",
    component: () => import("/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/othermanage/edSetting.vue").then(m => m.default || m)
  },
  {
    name: "manage-othermanage-element",
    path: "othermanage/element",
    component: () => import("/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/othermanage/element.vue").then(m => m.default || m)
  },
  {
    name: "manage-othermanage-hightLight",
    path: "othermanage/hightLight",
    component: () => import("/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/othermanage/hightLight.vue").then(m => m.default || m)
  },
  {
    name: "manage-othermanage-Hightlight-package-package",
    path: "othermanage/Hightlight/package/:package()",
    component: () => import("/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/othermanage/Hightlight/package/[package].vue").then(m => m.default || m)
  },
  {
    name: "manage-othermanage-hightLightPackage",
    path: "othermanage/hightLightPackage",
    component: () => import("/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/othermanage/hightLightPackage.vue").then(m => m.default || m)
  },
  {
    name: "manage-othermanage-pnrSetting",
    path: "othermanage/pnrSetting",
    component: () => import("/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/othermanage/pnrSetting.vue").then(m => m.default || m)
  },
  {
    name: "manage-othermanage-printSetting",
    path: "othermanage/printSetting",
    component: () => import("/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/othermanage/printSetting.vue").then(m => m.default || m)
  },
  {
    name: "manage-othermanage-QA-package-package",
    path: "othermanage/QA/package/:package()",
    component: () => import("/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/othermanage/QA/package/[package].vue").then(m => m.default || m)
  },
  {
    name: "manage-othermanage-qalist",
    path: "othermanage/qalist",
    component: () => import("/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/othermanage/qalist.vue").then(m => m.default || m)
  },
  {
    name: "manage-othermanage-qapackage",
    path: "othermanage/qapackage",
    component: () => import("/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/othermanage/qapackage.vue").then(m => m.default || m)
  },
  {
    name: "manage-othermanage-remark",
    path: "othermanage/remark",
    component: () => import("/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/othermanage/remark.vue").then(m => m.default || m),
    children: [
  {
    name: "manage-othermanage-remark-package-package",
    path: "package/:package()",
    component: () => import("/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/othermanage/remark/package/[package].vue").then(m => m.default || m)
  }
]
  },
  {
    name: "manage-othermanage-remarkPackage",
    path: "othermanage/remarkPackage",
    component: () => import("/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/othermanage/remarkPackage.vue").then(m => m.default || m)
  },
  {
    name: "manage-otherManagement",
    path: "otherManagement",
    component: () => import("/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/otherManagement.vue").then(m => m.default || m)
  },
  {
    name: "manage-outData",
    path: "outData",
    component: () => import("/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/outData.vue").then(m => m.default || m)
  },
  {
    name: "manage-overview",
    path: "overview",
    component: () => import("/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/overview.vue").then(m => m.default || m)
  },
  {
    name: "manage-parameter-method",
    path: "parameter/:method()",
    component: () => import("/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/parameter/[method].vue").then(m => m.default || m)
  },
  {
    name: "manage-payClosing",
    path: "payClosing",
    component: () => import("/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/payClosing.vue").then(m => m.default || m)
  },
  {
    name: "manage-paymentDeposit",
    path: "paymentDeposit",
    component: () => import("/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/paymentDeposit.vue").then(m => m.default || m)
  },
  {
    name: "manage-paymentManagement",
    path: "paymentManagement",
    component: () => import("/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/paymentManagement.vue").then(m => m.default || m)
  },
  {
    name: "manage-paymentReceipt",
    path: "paymentReceipt",
    component: () => import("/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/paymentReceipt.vue").then(m => m.default || m)
  },
  {
    name: "manage-paymentReceiptOpen",
    path: "paymentReceiptOpen",
    component: () => import("/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/paymentReceiptOpen.vue").then(m => m.default || m)
  },
  {
    name: "manage-paymentSetting",
    path: "paymentSetting",
    component: () => import("/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/paymentSetting.vue").then(m => m.default || m)
  },
  {
    name: "manage-ProClosing",
    path: "ProClosing",
    component: () => import("/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/ProClosing.vue").then(m => m.default || m)
  },
  {
    name: "manage-product",
    path: "product",
    component: () => import("/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/product.vue").then(m => m.default || m)
  },
  {
    name: "manage-proFunc-method-docMethod-product",
    path: "proFunc/:method()/:docMethod()/:product()",
    component: () => import("/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/proFunc/[method]/[docMethod]/[product].vue").then(m => m.default || m)
  },
  {
    name: "manage-proFunc-method-addPurchase-product",
    path: "proFunc/:method()/addPurchase/:product()",
    component: () => import("/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/proFunc/[method]/addPurchase/[product].vue").then(m => m.default || m)
  },
  {
    name: "manage-proFunc-method-contract-product",
    path: "proFunc/:method()/contract/:product()",
    component: () => import("/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/proFunc/[method]/contract/[product].vue").then(m => m.default || m)
  },
  {
    name: "manage-proFunc-method-edcard-product",
    path: "proFunc/:method()/edcard/:product()",
    component: () => import("/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/proFunc/[method]/edcard/[product].vue").then(m => m.default || m)
  },
  {
    name: "manage-proFunc-method-eedoc-product",
    path: "proFunc/:method()/eedoc/:product()",
    component: () => import("/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/proFunc/[method]/eedoc/[product].vue").then(m => m.default || m)
  },
  {
    name: "manage-proFunc-method-hotelList-product",
    path: "proFunc/:method()/hotelList/:product()",
    component: () => import("/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/proFunc/[method]/hotelList/[product].vue").then(m => m.default || m)
  },
  {
    name: "manage-proFunc-method-pnrSetting-product",
    path: "proFunc/:method()/pnrSetting/:product()",
    component: () => import("/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/proFunc/[method]/pnrSetting/[product].vue").then(m => m.default || m)
  },
  {
    name: "manage-proFunc-method-price-product-type",
    path: "proFunc/:method()/price/:product()/:type()",
    component: () => import("/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/proFunc/[method]/price/[product]/[type].vue").then(m => m.default || m)
  },
  {
    name: "manage-proFunc-method-print-product",
    path: "proFunc/:method()/print/:product()",
    component: () => import("/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/proFunc/[method]/print/[product].vue").then(m => m.default || m)
  },
  {
    name: "manage-proFunc-method-QA-product",
    path: "proFunc/:method()/QA/:product()",
    component: () => import("/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/proFunc/[method]/QA/[product].vue").then(m => m.default || m)
  },
  {
    name: "manage-proFunc-method-QApackage-product",
    path: "proFunc/:method()/QApackage/:product()",
    component: () => import("/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/proFunc/[method]/QApackage/[product].vue").then(m => m.default || m)
  },
  {
    name: "manage-proFunc-method-remark-product",
    path: "proFunc/:method()/remark/:product()",
    component: () => import("/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/proFunc/[method]/remark/[product].vue").then(m => m.default || m)
  },
  {
    name: "manage-proFunc-method-roomList-product",
    path: "proFunc/:method()/roomList/:product()",
    component: () => import("/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/proFunc/[method]/roomList/[product].vue").then(m => m.default || m)
  },
  {
    name: "manage-proFunc-method-special-product",
    path: "proFunc/:method()/special/:product()",
    component: () => import("/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/proFunc/[method]/special/[product].vue").then(m => m.default || m)
  },
  {
    name: "manage-proFunc-method-traffic-product",
    path: "proFunc/:method()/traffic/:product()",
    component: () => import("/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/proFunc/[method]/traffic/[product].vue").then(m => m.default || m)
  },
  {
    name: "manage-report-month",
    path: "report/month",
    component: () => import("/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/report/month.vue").then(m => m.default || m)
  },
  {
    name: "manage-report-viewReport",
    path: "report/viewReport",
    component: () => import("/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/report/viewReport.vue").then(m => m.default || m)
  },
  {
    name: "manage-report-year",
    path: "report/year",
    component: () => import("/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/report/year.vue").then(m => m.default || m)
  },
  {
    name: "manage-SettingSendManage",
    path: "SettingSendManage",
    component: () => import("/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/SettingSendManage.vue").then(m => m.default || m)
  },
  {
    name: "manage-template",
    path: "template",
    component: () => import("/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/template.vue").then(m => m.default || m)
  },
  {
    name: "manage-ThirdPartyPayment",
    path: "ThirdPartyPayment",
    component: () => import("/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/manage/ThirdPartyPayment.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "memberlogin",
    path: "/memberlogin",
    component: () => import("/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/memberlogin.vue").then(m => m.default || m)
  },
  {
    name: "membersignup",
    path: "/membersignup",
    component: () => import("/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/membersignup.vue").then(m => m.default || m)
  },
  {
    name: "signup",
    path: "/signup",
    component: () => import("/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/signup.vue").then(m => m.default || m)
  },
  {
    name: "verification",
    path: "/verification",
    component: () => import("/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/pages/verification.vue").then(m => m.default || m)
  },
  {
    name: "LeaderGroup",
    path: "/LeaderGroup",
    component: () => import("~/pages/LeaderGroup/[loginCode].vue").then(m => m.default || m)
  },
  {
    name: manageAwBqtF9fvfMeta?.name,
    path: "/manage",
    component: () => import("~/pages/manage.vue").then(m => m.default || m),
    children: [
  {
    name: "manage-myWaitGroup",
    path: "/manage/myWaitGroup",
    meta: {"title":"待處理旅團"},
    component: () => import("~/pages/manage/myGroup").then(m => m.default || m)
  },
  {
    name: "manage-myTrashGroup",
    path: "/manage/myTrashGroup",
    meta: {"title":"垃圾桶旅團"},
    component: () => import("~/pages/manage/myGroup").then(m => m.default || m)
  }
]
  }
]